import React, { useEffect, useState } from "react";
import CustomTable from "../../../../components/Tables/CustomTable";
import { useAppDispatch, useAppSelector } from "../../../../redux/app/hooks";
import {
  fetchReferredUsersAsync,
  resetAdminState,
  setSelectedUser,
} from "../../../../redux/features/adminSlice";
import WhiteTitledCard from "../../../../components/cards/WhiteTitledCard";
import SearchInput from "../../../../components/form/SearchInput";
import Button from "../../../ui/Button";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import DropdownMenu from "../../../ui/DropdownMenu";
import { MoreVertical } from "lucide-react";

const ReferredTable: React.FC = () => {
  const { ReferredUsers, isLoading } = useAppSelector((state) => state.admin);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [filter, setFilter] = useState("");
  const [inputValue, setInputValue] = useState("");
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const referredUsersOption = [
    {
      label: "View transactions",
      onClick: (user: any) => {
        navigate(`/user-management/referred/transactions`);
        dispatch(setSelectedUser(user));
      },
      returnAll: true,
    },
  ];

  const columns = [
    { label: "S/N", field: "id" },
    { label: "Name of Referred", field: "Referred_name" },
    { label: "Email", field: "email" },
    { label: "Referrer Code", field: "code" },
    { label: "Reg. Date", field: "date_added" },
    { label: "Action", field: "action" },
  ];

  const ReferredData = ReferredUsers?.data?.items?.map(
    (Referred: any, index: number) => {
      return {
        _referredUser: Referred,
        id: index + 1,
        Referred_name: Referred?.firstName + " " + Referred?.lastName,
        country: Referred?.country?.name ?? "N/A",
        email: Referred?.email ?? "N/A",
        code: Referred?.referrerCode ?? "N/A",
        date_added: moment(Referred?.createdAt).format("MMM DD, YYYY"),
        action: (
          <DropdownMenu
            options={referredUsersOption}
            icon={
              <MoreVertical style={{ cursor: "pointer" }} className="z-0" />
            }
            item={Referred}
          />
        ),
      };
    },
  );

  useEffect(() => {
    dispatch(resetAdminState());
    dispatch(
      fetchReferredUsersAsync({
        page: page + 1,
        limit,
        referralCode: filter,
      }),
    );
  }, [page, limit, filter, dispatch]);

  const tabList = [
    {
      id: 1,
      name: "All Referred Users",
      count: ReferredUsers?.data?.meta?.totalItems ?? 0,
    },
  ];

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      setFilter(inputValue);
    }
  };

  return (
    <WhiteTitledCard>
      <div className="px-6">
        <div className="flex flex-col md:justify-between gap-4 mb-4">
          {/* Tabs List */}
          {/* Search and Filter */}
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-2 w-full md:w-auto">
            <div className="flex gap-2">
              <SearchInput
                placeholder="Search"
                onChange={(e: any) => {
                  setInputValue(e.target.value);
                  setPage(0);
                }}
                value={inputValue}
                onKeyDown={handleKeyDown}
              />
              <Button
                customStyle={{
                  width: "auto",
                  height: "40px",
                }}
                label="Filter"
                onClick={() => setFilter(inputValue)}
                classNames="hidden sm:flex"
              />
            </div>
          </div>

          <div className="flex flex-col md:flex-row flex-wrap items-center gap-3">
            {tabList?.map((tab) => (
              <div
                key={tab.id}
                className="space-x-2 cursor-pointer text-sm font-semibold p-2 text-black border-b-2 border-primary"
              >
                <span>{tab.name}</span>
                <span className="bg-lightPurple px-2 text-accent rounded-md">
                  {tab?.count}
                </span>
              </div>
            ))}
          </div>
        </div>

        <CustomTable
          data={{ columns, rows: ReferredData }}
          onRowClick={(row) => {
            navigate(`/user-management/referred/transactions`);
            dispatch(setSelectedUser(row._referredUser));
          }}
          noRecordText="No Referred Users Available"
          loading={isLoading}
          showFooter={true}
          totalPages={ReferredUsers?.data?.meta?.totalPages}
          itemsPerPage={ReferredUsers?.data?.meta?.itemsPerPage}
          currentPage={page}
          onPageChange={(value: number) => setPage(value)}
          onLimitChange={(value: number) => {
            setLimit(value);
            setPage(0);
          }}
        />
      </div>
    </WhiteTitledCard>
  );
};

export default ReferredTable;
